


const ExplainerDetails = ({ details, rephraser_confidence_score }: any) => {
    // Extract metadata items for display
    const metadataItems = details?.metadata; 
    const hasMetadata = metadataItems && Object.keys(metadataItems).length > 0 && Object.values(metadataItems).every(value => value !== '' && value != null);
    return (
        <div className="flex flex-col gap-3">
            <div>
                <p className="text-default-600 text-base font-medium">Query</p>
                <div id={`query-textfield`} className="p-3 mt-2 border-2 border-default-300 rounded-lg" title={details?.query}>
                    {details?.query}
                </div>
            </div>
            <div className="flex flex-col">
                <span className="font-medium text-lg">Metadata</span>
                <span className="text-sm font-normal mt-1">Narrow down the pool of searchable documents by applying filters based on metadata</span>
                {hasMetadata && (
                    <div className="flex flex-wrap gap-2 mt-2">
                        {Object.entries(metadataItems).map(([key, value]) => (
                            <div 
                                key={key} 
                                className="border border-default-300 bg-default-100 px-2 py-1 rounded text-foreground text-xs"
                                title={`${key}: ${String(value)}`}
                            >
                                <span className="font-medium">{String(value)}</span> 
                            </div>
                        ))}
                    </div>
                )}
                {!hasMetadata && (
                    <div className="text-sm text-default-500 mt-2">No metadata available</div>
                )}
            </div>
            <div className="flex flex-row gap-4 font-medium">
                <span>Total Sources: <span className="text-danger">{details?.total_knowledge}</span></span>
                <span>Snippets: <span className="text-danger">{details?.top_results}</span></span>
            </div>
            <div>
                <p className="text-default-600 text-base font-medium">Rephrased Query</p>
                <div id={`rephrasedquery-textfield`} className="p-3 mt-2 border-2 border-default-300 rounded-lg">
                    {details?.rephrased_query}
                </div>
            </div>
            {rephraser_confidence_score !== undefined && rephraser_confidence_score !== null && rephraser_confidence_score !== '' && (
                <div>
                    <span className="text-default-600 text-base font-medium">Rephraser Confidence Score: {rephraser_confidence_score}</span>
                </div>
            )}
        </div>
    )
}

export default ExplainerDetails;